/*
 * Consenso cookie per noleggio (usato solo quando il noleggio ha un container GTM).
 *
 * - Il consenso e' salvato in localStorage per noleggio: ogni noleggio e' un titolare
 *   diverso, quindi la scelta fatta su uno shop non vale per gli altri.
 * - Scade dopo 6 mesi (linee guida Garante): poi il banner viene riproposto.
 * - Le categorie vengono tradotte negli stati di Google Consent Mode v2.
 */

const STORAGE_PREFIX = "ns_consent_";
const CONSENT_VERSION = 1;
const MAX_AGE_MS = 1000 * 60 * 60 * 24 * 182; // ~6 mesi

function storageKey(codiceNoleggio) {
  return STORAGE_PREFIX + String(codiceNoleggio).toUpperCase();
}

// Restituisce { analytics, marketing } oppure null se assente / scaduto / non valido
export function readConsent(codiceNoleggio) {
  if (!codiceNoleggio) return null;
  try {
    const raw = window.localStorage.getItem(storageKey(codiceNoleggio));
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.v !== CONSENT_VERSION) return null;
    if (typeof data.ts !== "number" || Date.now() - data.ts > MAX_AGE_MS)
      return null;
    return { analytics: !!data.analytics, marketing: !!data.marketing };
  } catch (e) {
    return null;
  }
}

export function writeConsent(codiceNoleggio, { analytics, marketing }) {
  try {
    window.localStorage.setItem(
      storageKey(codiceNoleggio),
      JSON.stringify({
        v: CONSENT_VERSION,
        ts: Date.now(),
        analytics: !!analytics,
        marketing: !!marketing,
      })
    );
  } catch (e) {
    // storage non disponibile (es. navigazione privata): il consenso vale solo per la pagina
  }
}

export function toConsentModeState({ analytics, marketing }) {
  const v = (granted) => (granted ? "granted" : "denied");
  return {
    analytics_storage: v(analytics),
    ad_storage: v(marketing),
    ad_user_data: v(marketing),
    ad_personalization: v(marketing),
    personalization_storage: v(marketing),
  };
}

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

// Invia a GTM l'aggiornamento del consenso (+ un evento per eventuali trigger)
export function applyConsent(consent) {
  gtag("consent", "update", toConsentModeState(consent));
  window.dataLayer.push({
    event: "consent_update",
    consent_analytics: !!consent.analytics,
    consent_marketing: !!consent.marketing,
  });
}
